<template lang="pug">
  v-dialog(v-model='dialogSchemaPro' scrollable max-width='100%' persistent)
    v-card(color='grey_1')
      v-app-bar(dark color='primary')
        v-toolbar-title.headline Especificaciones de los productos
      v-card-text
        v-col(cols='12' sm='12' md='12')
          v-card(color='white')
            v-card-text
              v-row(dense)
                v-col(cols='12' sm='12' md='12')
                  v-data-table.elevation-1(:headers='headers' item-key='productos' :items='productos' :search='search' sort-by='codigo' :loading='loading' loading-text='Cargando, por favor espere...')
                    template(v-slot:top)
                      v-toolbar(flat color='primary' dark)
                        v-toolbar-title.justify-center Productos
                        v-divider.mx-4(inset vertical)
                        v-spacer
                        v-text-field.text-xs-center(v-model='search', label='Búsqueda', single-line, hide-details, color='success')
                        v-spacer
                        SchemaProAdd(:dialogSchemaProAdd='dialogSchemaProAdd' :editedIndex='editedIndex' @edited='listarProductos'
                          :FormPadre='editedItem' @close='close' :productos='productos' :mostrar='mostrar')
                    template(v-slot:item.action='{ item }')
                      v-tooltip(bottom='')
                        template(v-slot:activator='{ on }')
                          v-icon.mr-2(v-if='validarModificar()', color='warning', @click='editItem(item)' v-on="on") mdi-pencil
                        | Editar
                    template(v-slot:no-data='')
                      h1 Inserte un documento Excel
      v-card-actions
        v-spacer
        v-btn(color='error' dark @click='closeDialogSchemaPro')
          v-icon mdi-close
          | Salir
</template>

<script>
import Api from '@/services/methods'
import SchemaProAdd from './SchemaProAdd' 
export default {
  props: ['dialogSchemaPro'],
  name: 'SchemaPro',
  data: () => ({
    search: '',
    loading: true,
    dialog: false,
    mostrar: true,
    productos: [],
    permisosRuta: {},
    idPreArray: [],
    presentacionM: false,
    dialogSchemaProAdd: false,
    selecPre: '',
    headers: [
      { text: 'Codigo', value: 'nombre', align: 'left' },
      { text: 'Descripcion', value: 'descripcion', align: 'center' },
      { text: 'Costo', value: 'costo', align: 'center' },
      { text: 'Acciones', value: 'action', sortable: false, align: 'right' }
    ],
    editedIndex: -1,
    editedItem: {
        _id: '',
        codPortafolio: null,
        idFabricante: null,
        idMarca: null,
        idLinea: null,
        sublinea: null,
        presentacion: null,
        idAlmacen: null,
        idIva: null
    },
    defaultItem: {
        _id: '',
        codPortafolio: null,
        idFabricante: null,
        idMarca: null,
        idLinea: null,
        sublinea: null,
        presentacion: null,
        idAlmacen: null,
        idIva: null
    },
  }),

  components: {
    SchemaProAdd
  },


  watch: {
    dialog (val) {
      val || this.closeDialogSchemaPro()
    }
  },

  created () {
    this.initialize()
    this.permisosRuta = this.$store.state.empresa[0].permisos.find(
      permiso => permiso.ruta === 'Producto'
    )
  },

  methods: {
    initialize () {
      this.listarProductos()
    },

    validarModificar () {
      return this.permisosRuta?.accion.includes('Modificar')
    },

    close () {
      this.dialogSchemaProAdd = false
    },

    closeDialogSchemaPro () {
      setTimeout(() => {
      }, 300)
      this.$emit('close')
    },

    listarProductos () {
      Api.get('producto/proConfig')
        .then(response => {
          this.productos = response.data
          this.loading = false
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
              //text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message);
          }
        })
    },

    editItem (item) {

      Api.post('producto/consultaProAlma', item)
        .then(response => {
          if (response.data.status === 'empty') {
            this.mostrar = true
          } else if (response.data.status === 'data') {
            this.mostrar = false
          }
        })
        .catch(error => { })

      this.editedIndex = this.productos.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialogSchemaProAdd = true
    },

    
  }
}
</script>

<style lang="scss">  

.v-data-table th {
  font-size: 15px;
}

.v-data-table td {
  font-size: 13px;
}

.v-application .text-start {
    text-align: center !important;
}

.button_s {
  width: 78px;
  margin: 5px 10px 5px 5px;
}
.button_m {
  width: 100px;
  margin: 5px 10px 5px 5px;
}
.my_file {
  position: relative;
  .my_input {
    position: absolute;
    opacity: 0;
    width: 78px;
    height: 30px;
    top: 0;
    left: 0;
  }
}

</style>
